import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { Button, Modal, UnstyledButton } from "@mantine/core";
import { useSelector } from "react-redux";
import { SaleContext } from "../common/saleProvider";
import CountdownContent from "./CountdownContent";
import { Context, OPEN_CART } from "../../context";
import classes from "./CountdownContainer.module.css";

const TimerWarning = (props) => {
  const forceReload = () => {
    window.location.reload();
  };

  const { isOpenModal, language } = props;

  return (
    <Modal onClose={() => null} withCloseButton={false} opened={isOpenModal}>
      <h2 style={{ padding: "16px 24px" }}>
        {language ? language.Information : "Information"}
      </h2>
      <div style={{ padding: "16px 24px" }}>
        {language.Article_Expired
          ? language.Article_Expired
          : "Reservationstiden för ditt köp har utgått och din varukorg har uppdaterats. Kontrollera din varukorg och försök igen."}
      </div>
      <div className={classes.modalActions}>
        <Button onClick={forceReload}>
          {language ? language.Close : "Stäng"}
        </Button>
      </div>
    </Modal>
  );
};

const CountdownContainer = ({ changeBackground, paddingLeft }) => {
  const { dispatch } = useContext(Context);
  const {
    state: { sale },
  } = useContext(SaleContext);

  const { language } = useSelector((state) => ({
    language: state.language,
  }));
  const [itemQuantity, setItemQuantity] = useState(0);
  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    if (sale && sale?.itemQuantity) {
      setItemQuantity(sale.itemQuantity);
    } else {
      setItemQuantity(0);
    }
  }, [sale]);

  const isAllotment = sale?.items.some((el) => el.allotmentId);

  if (!isAllotment) return null;
  if (isOpenModal) {
    return <TimerWarning isOpenModal={isOpenModal} language={language} />;
  } else {
    if (itemQuantity > 0) {
      return (
        <div className={paddingLeft && classes.paddingLeft}>
          <UnstyledButton
            className={`${clsx(classes.countDownText)} countDownText`}
            onClick={() => dispatch({ type: OPEN_CART })}
            disabled={sale.itemQuantity < 1}
            classes={{ disabled: classes.disabled }}
            aria-label={language.OpenCart}
            style={{
              width: "fit-content",
              height: "fit-content",
            }}
          >
            <CountdownContent
              sale={sale}
              language={language}
              openModal={setIsOpenModal}
              changeBackground={changeBackground}
            />
          </UnstyledButton>
        </div>
      );
    } else {
      return null;
    }
  }
};

export default CountdownContainer;
